































































































































import { Vue, Component } from 'vue-property-decorator';

import { appName } from '@/env';
import { readDashboardMiniDrawer, readDashboardShowDrawer, readHasAdminAccess, readIsLoggedIn, readUserProfile } from '@/store/main/getters';
import { commitSetDashboardShowDrawer, commitSetDashboardMiniDrawer } from '@/store/main/mutations';

import {
  FmvHeaderLayout,
  FmvDrawerLayout,
  FmvSidebar,
  FmvSidebarMenu,
} from 'fmv-layout';
import {FmvAvatar} from 'fmv-avatar';
import AppNavbar from '../../components/Navbar/Navbar.vue';
import AppSidebar from '../../components/Sidebar/Sidebar.vue';
import AppFooter from '../../components/Footer/Footer.vue';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import {elementScrollIntoView} from 'seamless-scroll-polyfill';
import store from '@/store';
import { dispatchCheckMenuAccess } from '@/store/main/actions';

const routeGuardMain = async (to, from, next) => {
  if (to.path === '/') {
    next('/dashboard');
  } else {
    const isLoggedIn = readIsLoggedIn(store);
    if (to.path !== '/subscription' && isLoggedIn) {
      const result = await dispatchCheckMenuAccess(store, {url: to.path});
      if (!result.allow) {
        next('/subscription');
        return;
      }
    }
    next();
  }
}

@Component({
  components: {
    FmvHeaderLayout,
    FmvDrawerLayout,
    FmvAvatar,
    MdIcon,
    FmvSidebar,
    FmvSidebarMenu,
    AppNavbar,
    AppSidebar,
    AppFooter,
  },
})
export default class Main extends Vue {
  public appName = appName;
  /* MAIN PROPS */
  public drawerAlign = 'start';
  public containerClass = 'container-fluid page__container';
  public drawerLayoutContentId = 'drawer-layout-content';
  public drawerLayoutResponsiveWidth = '992px';
  public drawerLayoutClass = null;
  public subLayout = false;

  public headerEffects = 'waterfall';
  public headerClass = 'mb-0';
  public sidebarClass = 'sidebar-p-t';

  /* NAVBAR PROPS */
  public navbarVariant = 'white navbar-shadow';
  public navbarType = 'light';
  public navbarClass = null;
  public navbarToggleClass = 'd-lg-none';
  public brandLogo = 'src/assets/images/logo.svg';
  public navbarContentContainerClass = 'd-flex w-100 align-items-center';
  public navbarContainerClass = 'd-flex w-100 align-items-center';
  public navbarBrand = 'Brand';
  public navbarBrandClass = null;
  public navbarFullSampleGuestMode = false;
  public navbarSearch = false;
  /* SIDEBAR PROPS */
  public sidebarType = 'light';
  public sidebarVariant = null;
  public sidebarBrand = null;
  public brandImage = '/';
  public sidebarBrandClass = null;
  public sidebarSearch = false;
  public sidebarSearchFormClass = null;
  public sidebarMenu = true;
  public scrollIntoViewElement = 'scrollIntoView';
  /* SUB LAYOUT PROPS */
  public subLayoutResponsiveWidth = '992px';
  public subLayoutDrawerAlign = 'end';
  public subLayoutDrawerId = 'sub-layout-drawer';
  public subLayoutDrawer = false;
  public subLayoutHasScrollingRegion = true;
  public hasFooter = true;
  public props = null;

  public footerClass = 'bg-white border-top-2';
  public footerContainerClass = null;
  public footerBrand = 'unifordi';
  public footerLogo = null;
  public footerCopyrightYear = null;
  public footerCopyrightText = null;
  public footerDescriptionText = null;
  public showEmailWarn = true;

  public beforeRouteEnter(to, from, next) {
    routeGuardMain(to, from, next);
  }

  public beforeRouteUpdate(to, from, next) {
    routeGuardMain(to, from, next);
  }

  get miniDrawer() {
    return readDashboardMiniDrawer(this.$store);
  }

  get showDrawer() {
    return readDashboardShowDrawer(this.$store);
  }

  set showDrawer(value) {
    commitSetDashboardShowDrawer(this.$store, value);
  }

  public switchShowDrawer() {
    commitSetDashboardShowDrawer(
      this.$store,
      !readDashboardShowDrawer(this.$store),
    );
  }

  public switchMiniDrawer() {
    commitSetDashboardMiniDrawer(
      this.$store,
      !readDashboardMiniDrawer(this.$store),
    );
  }

  public get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  public get isLoggedIn() {
    return readIsLoggedIn(this.$store);
  }

  public get userProfile() {
    return readUserProfile(this.$store);
  }

  public scrollIntoView() {
    this.$nextTick(() => {
      const target = document.querySelector(`#${this.scrollIntoViewElement}`);
      if (target) {
        elementScrollIntoView(target, {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    });
  }
  public defaultSlotProps() {
    const props = {};
    /* tslint:disable */
    Object.keys(this.$props).map(prop => props[prop] = this[prop]);
    return props;
    /* tslint:enable */
  }
}
